module.exports = __webpack_public_path__ + "static/media/logo-dark-theme.5c685b9a.svg";